"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const user_png_1 = __importDefault(require("../../assets/user.png"));
const chatEvents_1 = __importDefault(require("../../lib/chatEvents"));
const configureStore_1 = require("../../store/configureStore");
const ChatHead = (props) => {
    const { socket } = props;
    const [headCount, setHeadCount] = (0, react_1.useState)([]);
    const { room, handleStep, handleRoom, handleIsModal, handleModalContents } = (0, react_1.useContext)(configureStore_1.StoreContext);
    const Events = new chatEvents_1.default(socket);
    const headCountModal = () => {
        handleModalContents(react_1.default.createElement("ul", { style: {
                display: "flex",
                flexFlow: "column nowrap",
                flex: "1",
                margin: "0",
                padding: "0",
                listStyle: "none",
                overflow: "auto",
            } }, headCount.map((id, idx) => react_1.default.createElement("li", { key: idx, style: {
                margin: "12px",
                padding: "8px",
                textAlign: "center",
                color: "#e4e2b0",
                border: "1px solid #969595"
            } },
            idx + 1,
            " : ",
            id))));
    };
    const openUserList = () => {
        headCountModal();
        handleIsModal(true);
    };
    const leaveRoom = () => {
        Events.leaveRoom(room);
        handleRoom('');
        handleStep(3);
    };
    (0, react_1.useEffect)(() => {
        if (room !== '') {
            Events.receiveHeadCount(room, setHeadCount);
        }
        return () => {
            setHeadCount([]);
        };
    }, [room]);
    (0, react_1.useEffect)(() => {
        if (headCount.length > 0) {
            headCountModal();
        }
    }, [headCount]);
    return (react_1.default.createElement("div", { "data-testid": "chat-head", style: {
            display: "flex",
            height: "48px",
            background: "rgb(230, 221, 196)"
        } },
        react_1.default.createElement("nav", { style: {
                display: "flex",
                flex: "1"
            } },
            react_1.default.createElement("img", { src: user_png_1.default, style: {
                    width: "30px",
                    height: "30px",
                    margin: "9px",
                }, onClick: openUserList }),
            react_1.default.createElement("h2", { style: {
                    margin: "12px 0",
                    fontSize: "1rem",
                    color: "rgb(103, 137, 131)"
                } },
                room || "#1",
                react_1.default.createElement("span", { style: {
                        color: "rgb(57, 80, 76)"
                    } },
                    "(",
                    headCount.length,
                    ")"))),
        react_1.default.createElement("button", { type: "button", title: "\uBC29\uC5D0\uC11C \uB098\uAC00\uAE30", style: {
                background: "none",
                border: "none",
                fontSize: "1rem",
                fontWeight: 600,
                color: "#464545",
            }, onClick: leaveRoom }, "X")));
};
exports.default = ChatHead;
